// Acces au stockage du navigateur qui n'echoue jamais.
//
// Les navigateurs integres (Instagram, Facebook, TikTok), la navigation privee et les reglages
// stricts de confidentialite peuvent REFUSER l'acces a sessionStorage : la simple lecture ou
// ecriture leve alors une exception. Ces exceptions faisaient tomber le demarrage de
// l'application et bloquaient la redirection vers l'inscription.
//
// Ce stockage ne sert qu'a du confort (savoir si la connexion vient d'avoir lieu). Son
// indisponibilite ne doit jamais empecher un visiteur d'avancer.

export function readSessionItem(key) {
  try {
    return sessionStorage.getItem(key)
  } catch (e) {
    return null
  }
}

export function writeSessionItem(key, value) {
  try {
    sessionStorage.setItem(key, value)

    return true
  } catch (e) {
    return false
  }
}

export function removeSessionItem(key) {
  try {
    sessionStorage.removeItem(key)

    return true
  } catch (e) {
    return false
  }
}

// Meme protection pour le stockage persistant. `src/store/auth.module.js` le lisait AU NIVEAU
// DU MODULE, donc a l'import, hors de toute protection : un stockage refuse produisait une page
// entierement blanche, sans message ni trace.

export function readLocalItem(key) {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

export function writeLocalItem(key, value) {
  try {
    localStorage.setItem(key, value)

    return true
  } catch (e) {
    return false
  }
}

export function removeLocalItem(key) {
  try {
    localStorage.removeItem(key)

    return true
  } catch (e) {
    return false
  }
}

// La presence est deduite de la lecture, et non de l'enumeration des proprietes : selon
// l'implementation, les cles ne sont pas toujours exposees comme proprietes propres.
// getItem ne rend null que si la cle est absente, la valeur stockee etant toujours une chaine.
export function hasLocalItem(key) {
  return readLocalItem(key) !== null
}
